import React from 'react';
import SubHeader from '../../../common/subHeader';
import Divider from '../../../common/divider';

const DisputeModalDetailsSection = (props) => {

    let dispute = props.dispute;
    return (
        <div>
            <Divider />
            <SubHeader title="Details" />
            <Divider />
            <div className="row">
                <div className="col-md-6 dispute-col" >
                    <div>
                        <label>Issuer:</label>
                        <label>{dispute.issuer}</label>
                    </div>
                     {dispute.merchant &&
                        <div>
                            <label>Merchant:</label>
                            <label>{dispute.merchant}</label>
                        </div>
                    }
                    <div>
                        <label>Acquirer:</label>
                        <label>{dispute.acquirer}</label>
                    </div>
                   
                    
                    <div>
                        <label>Tran. Date:</label>
                        <label>{dispute.transactionDate}</label>
                    </div>
                    
                    <div>
                        <label>Tran. Type:</label>
                        <label>{dispute.transactionType}</label>
                    </div>
                    <div>
                        <label>Tran. Amount:</label>
                        <label>{dispute.transactionAmount ? `${dispute.transactionCurrency} ${dispute.transactionAmount}` : "-"}</label>
                    </div>
                    <div>
                        <label>Tran. Ref.:</label>
                        <label>{dispute.transactionReference}</label>
                    </div>

                    <div>
                        <label>Customer Ref.:</label>
                        <label>{dispute.customerReference}</label>
                    </div>
                    <div>
                        <label>Terminal Type:</label>
                        <label>{dispute.terminalType}</label>
                    </div>
                    <div>
                        <label>Additional Info :</label>
                        <textarea readOnly="true" style={{ width: "400px", height: "100px", fontSize: "12px" }} value={JSON.stringify(dispute.additionalInfo, null, 2)} />
                    </div>
                </div>
                <div className="col-md-6 dispute-col">
                    <div>
                        <label>Log Code:</label>
                        <label>{dispute.logCode}</label>
                    </div>
                    <div>
                        <label>Reason:</label>
                        <label>{dispute.reason}</label>
                    </div>
                    <div>
                        <label>Category:</label>
                        <label>{dispute.category}</label>
                    </div>
                    <div>
                        <label>Status:</label>
                        <label>{dispute.status}</label>
                    </div>
                    {dispute.statusScheduledEndDate &&
                        <div>
                            <label>Status Expires:</label>
                            <label>{dispute.statusScheduledEndDate}</label>
                        </div>
                    }
                    <div>
                        <label>Region:</label>
                        <label>{dispute.region}</label>
                    </div>
                    <div>
                        <label>Dispense Type:</label>
                        <label>{dispute.dispenseType}</label>
                    </div>
                    <div>
                        <label>Dispense Amount:</label>
                        <label>{dispute.dispensedAmount ? `${dispute.transactionCurrency} ${dispute.dispensedAmount}` : "-"}</label>
                    </div>

                    <div>
                        <label>Requested Amount:</label>
                        <label>{dispute.requestedAmount ? `${dispute.transactionCurrency} ${dispute.requestedAmount}` : "-"}</label>
                    </div>
                    <div>
                        <label>Created On:</label>
                        <label>{dispute.createdOn}</label>
                    </div>

                </div>


            </div>
        </div>
    );
}
export default DisputeModalDetailsSection;


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputesModalDetailsSection.js